import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

const Modal = ({ open, onClose, title, children, footer }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all min-w-[320px] mx-4 max-h-[90vh] flex flex-col data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 motion-reduce:transition-none"
          >
            {/* Header */}
            <div className="flex-none border-b">
              <div className="flex justify-between items-center px-4 py-3 sm:px-6">
                <DialogTitle className="text-lg font-medium flex-1">
                  {t(title)}
                </DialogTitle>
                <button
                  type="button"
                  className="ml-auto rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                  onClick={onClose}
                  aria-label={t("common.close")}
                >
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto overflow-x-hidden">
              <div className="px-4 py-3 sm:px-6">{children}</div>
            </div>

            {/* Footer */}
            {footer && (
              <div className="flex-none border-t">
                <div className="px-4 py-3 sm:px-6">{footer}</div>
              </div>
            )}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Modal;